import React from "react";
import GlimpsePopup from "components/popup/popup.component";
import Button from "components/button/button";

interface VideoFallbackModalProps {
  isOpen: boolean;
  onMarkViewed: () => void;
  onKeepWatching: () => void;
  isLoading?: boolean;
}

const VideoFallbackModal: React.FC<VideoFallbackModalProps> = ({
  isOpen,
  onMarkViewed,
  onKeepWatching,
  isLoading = false,
}) => {
  return (
    <GlimpsePopup
      popup={isOpen}
      onClose={onKeepWatching}
      showCross={true}
      customClass="max-w-[420px]"
    >
      <div className="flex flex-col items-center text-center gap-4">
        {/* Icon — play button with checkmark */}
        <div className="w-14 h-14 rounded-full bg-surface-muted flex items-center justify-center">
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Outer circle */}
            <circle cx="14" cy="14" r="13" stroke="#213269" strokeWidth="1.5" />
            {/* Play triangle */}
            <path
              d="M11 9L19 14L11 19V9Z"
              fill="#2B8565"
            />
            {/* Checkmark badge */}
            <circle cx="21" cy="21" r="5.5" fill="#2B8565" stroke="white" strokeWidth="1.5" />
            <path
              d="M19 21L20.5 22.5L23.5 19.5"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h3 className="text-h2 text-brand">
          Having trouble with this video?
        </h3>
        <p className="text-body text-text-muted">
          If you've finished watching the video, you can mark it as viewed to
          continue.
        </p>
        <div className="flex gap-3 w-full mt-2">
          <Button
            variant="secondary"
            className="flex-1"
            onClick={onKeepWatching}
          >
            Keep Watching
          </Button>
          <Button
            variant="primary"
            className="flex-1"
            onClick={onMarkViewed}
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Mark as Viewed"}
          </Button>
        </div>
      </div>
    </GlimpsePopup>
  );
};

export default VideoFallbackModal;
